/**
 * Notistack Ref for global notifications
 * Allows API interceptors to emit error toasts
 */
import { createRef } from 'react';

export const notistackRef = createRef();
